<div class="modal-header">
  <h4 class="modal-title pull-left">Duplicate Properties ({{duplicatePropertyList.length}})</h4>
  <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="form-group">
    <div class="table-responsive">
      <table class="table basictable row-border hover">
        <tbody>
          <tr *ngFor="let prop of duplicatePropertyList;let i = index ">
            <td>
              <div class="modal-data-box">
                <button type="button" class="close pull-right" *ngIf="(!Authentication.DataEntryStaff() || (Authentication.DataEntryStaff()&& prop.Is1031!==undefined&&prop.Is1031==true))" tooltip="Edit" placement="top" aria-label="Close" style="color:black" (click)="editPropertyConfirmation(DuplicateConfirmation,prop)">
                  <i aria-hidden="true" class="fa fa-pencil-square-o"></i>
                </button>
                <button type="button" class="close pull-right" *ngIf="(Authentication.DataEntryStaff()&& prop.Is1031!=undefined&&prop.Is1031==false)" tooltip="Request change" placement="top" aria-label="Close" style="color:black" (click)="onRequestChange(RequestChange,prop,'property-Offmarket')">
                  <i aria-hidden="true" class="icofont icofont-loop"></i>
                </button>
                <h4 style="font-weight:600;">
                  <a>{{prop.PropertyName}}</a>
                </h4>
                <p>{{prop.Address}}, {{prop.StateCode}}, {{prop.CityName}}, {{prop.Zip}}</p>
                <p>
                  <span class="tag" [ngClass]="{'redtext':(prop.PropertyStatus === 'Closed' || prop.PropertyStatus === 'Sold'),'greentext':prop.PropertyStatus === 'Available','gerytext':prop.PropertyStatus === 'Under Contract','ashtext':prop.PropertyStatus === 'Off-Market'}">
                    {{prop.PropertyStatus}}
                  </span>
                </p>
                <p>
                  {{prop.Status}}
                </p>
                <p *ngIf="prop.BrokerageName"><i class="icon-propertydetails icon"></i> {{prop.BrokerageName}}</p>
              </div>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr *ngIf="duplicatePropertyList?.length == 0 ">
            <td colspan="15" class="odd no-data-available">
              <div class="nodata">
                <i class="fa fa-exclamation-triangle icon"></i>
                <p>No Data Available</p>
              </div>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</div>

<ng-template #DuplicateConfirmation>
  <div class="modal-body padding30">
    <div class="form-group">
      <h6 class="displayvalue">This property is not associated with your brokerage. Are you sure you want to update? </h6>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="modalRefPropertyEditConfirmation.hide();">NO</button>
      <button class="btn btn-lg btn-success" (click)="editProperty(currentProperty)">YES</button>
    </div>
  </div>
</ng-template>
<ng-template #RequestChange>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Edit Property</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRefRequestChange.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body padding30">
    <div class="form-group">
      <label class="form-label">This property is currently saved as a B+E Listing, contact an admin to make required property updates</label>
    </div>
    <div class="form-group">
      <label class="form-label">Required Changes</label>
      <textarea class="form-control" [(ngModel)]="Comments" maxlength="500" rows="3"></textarea>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="modalRefRequestChange.hide()">Cancel</button>
      <button class="btn btn-success btn-lg" (click)="RequestEditToAdmin();">Request Change</button>
    </div>
  </div>
</ng-template>
